<template>
  <div class="checkout-total-group">
    <div class="group-head">
      <div class="group-head__top">
        <div class="group-head__wrapper">
          <checkout-label
            :title="`Заказ ${group.order}`"
            :type="group.type"
          />

          <span
            class="group-head__title"
            v-html="group.title">
          </span>
        </div>

        <chevron-animated
          class="group-head__chevron"
          :reverse="isOpened"
          @click.native="isOpened = !isOpened"
        />
      </div>

      <div class="group-head__subtitle">
        {{ group.subtitle }}
      </div>
    </div>

    <div class="dashed-table" v-show="isOpened">
      <div>
        <div>{{ group.productsCount }} {{ group.productsCount | decl('товар', ['', 'а', 'ов']) }} на сумму</div>
        <div class="price-rub">
          {{ group.subtotal.productsPrice || 0 | price }}
        </div>
      </div>
      <div>
        <div>Стоимость доставки</div>
        <div class="price-rub">
          {{ group.subtotal.shippingPrice || 0 | price }}
        </div>
      </div>
      <div
        class="discount accent"
        v-for="discount in group.discounts"
        :key="discount.sum"
      >
        <div>{{ discount.name }}</div>
        <div class="price-rub">
          - {{ discount.sum | price }}
        </div>
      </div>
      <div class="accent" v-if="group.subtotal.totalPrice">
        <div>Сумма заказа</div>
        <div class="price-rub">
          {{ group.subtotal.totalPrice || 0 | price }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckoutLabel from "../checkout-label";
import ChevronAnimated from "@/assets/icons/chevron-animated";

export default {
  name: "checkout-total-group",
  components: {
    ChevronAnimated,
    CheckoutLabel
  },

  props: {
    group: {
      type: Object,
      required: true
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isOpened: true
    }
  },
}
</script>

<style lang="scss">
.checkout-total-group {
  margin-top: 20px;

  .group-head {
    &__wrapper {
      width: calc(100% - 22px);
    }

    &__top {
      display: flex;

      & > svg {
        width: 22px;
        max-height: 24px;
        color: $gray_l;
      }
    }

    &__title {
      margin-left: 8px;
      font-size: 14px;
      line-height: 24px;
      font-weight: 600;
      vertical-align: bottom;

      span {
        color: $blue;
      }
    }

    &__chevron {
      margin-left: 17px;
    }

    &__subtitle {
      font-size: 14px;
      line-height: 24px;
      color: $gray;
    }
  }

  .dashed-table {
    margin-top: 10px;
    border-bottom: 1px solid $gray_lu;
    padding-bottom: 32px;
  }
}

@include breakpoint("tablet") {
  .checkout-total-group {
    .group-head {
      &__subtitle {
        max-width: 663px;
      }
    }
  }
}

@include breakpoint("desktop") {
  .checkout-total-group {
    margin-top: 24px;

    .group-head {
      &__top {
        display: flex;
      }

      &__chevron {
        cursor: pointer;
      }

      &__subtitle {
        margin-top: 4px;
        max-width: none;
      }

      &__title,
      &__subtitle {
        font-size: 16px;
      }
    }
  }
}
</style>
